var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, customElement, property } from "lit-element";
import styles from "./style";
import '../location-element';
import { sortLocations } from "../../utils/sort-locations";
let StatusElement = class StatusElement extends LitElement {
    constructor() {
        super(...arguments);
        this.locationOrder = ["Grimm-Zentrum", "Hauptgebäude 1.OG", "Hauptgebäude 2.OG", "Erwin Schrödinger-Zentrum", "CMS"];
        this.freshnessTimeoutMinutes = 15;
    }
    render() {
        logFetchedData(this.status);
        const status = Object.assign(Object.assign({}, this.status), { locations: sortLocations(this.status.locations, this.locationOrder) });
        return html `
      <div class="row">
        <connection-badge class="col-lg-4 col-md-6 col-sm-6" timestamp=${status.timestamp} freshnessTimeoutMinutes=${this.freshnessTimeoutMinutes}></connection-badge>
      </div>
      <div class="row">
        ${status.locations.map(location => html `<x-location class="col-lg-4 col-md-6" .location=${location}></x-location>`)}
      </div>
      
      <footer>
        <p>Timestamp: ${new Date(status.timestamp).toLocaleString()}</p>
        <a href="${this.fetchUrl}">Source</a> downloaded every ${this.updateIntervalSeconds} seconds
      </footer>
    `;
    }
};
StatusElement.styles = styles;
__decorate([
    property({ type: Array })
], StatusElement.prototype, "locationOrder", void 0);
__decorate([
    property({ type: Number })
], StatusElement.prototype, "freshnessTimeoutMinutes", void 0);
__decorate([
    property({ type: Object })
], StatusElement.prototype, "status", void 0);
__decorate([
    property({ type: String })
], StatusElement.prototype, "fetchUrl", void 0);
__decorate([
    property({ type: Number })
], StatusElement.prototype, "updateIntervalSeconds", void 0);
StatusElement = __decorate([
    customElement('status-element')
], StatusElement);
const logFetchedData = (json) => {
    console.groupCollapsed('Timestamp:', json.timestamp);
    json.locations.forEach(location => {
        console.groupCollapsed(location.name);
        location.terminals.forEach(terminal => console.log(terminal));
        console.groupEnd();
    });
    console.groupEnd();
};
